import { Component, Input, OnInit } from '@angular/core';
import { ReferenceDataLabels } from '../../../../lib/constants/reference-data-labels';
import { FormApplication } from '../../models/form-application.model';
import { ReferenceDataContextualHelps } from './../../../../lib/constants/reference-data-contextual-helps';
import { ReferenceDataOptionLists } from './../../../../lib/constants/reference-data-option-lists';

@Component({
  selector: 'boi-fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.scss']
})
export class FeesComponent implements OnInit {
  @Input() public application: FormApplication;
  @Input() public isFeeUpToDate = true;
  @Input() public shouldHideIsRecommendedCode = false;
  @Input() public isDprEnabled: boolean;

  public isBuildingSurveyNoteVisible = true;
  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public referenceDataContextualHelps = ReferenceDataContextualHelps;

  public shouldDisplayIsRecommendedCode: boolean;
  public isReportCompletedBeforeMortgageVisible: boolean;
  public isValuationReportTypeDisabled: boolean;
  public isValuationReportTypeCodeVisible: boolean;
  public isBuildingSurveyNoteAccepted = false;

  public ngOnInit(): void {
    this.shouldDisplayIsRecommendedCode = this.application.isAdvisedCase && !this.shouldHideIsRecommendedCode;
    this.isValuationReportTypeDisabled =
      !this.application.isPurchase || this.application.IsApplicationReadOnly || this.application.IsFactFindReadOnly;
    this.isReportCompletedBeforeMortgageVisible =
      this.application.isPurchase && this.application.isScottishProperty && this.application.isResidential;
    this.isValuationReportTypeCodeVisible =
      this.application.IsFactFind ||
      (this.application.Fee &&
        !(
          this.isReportCompletedBeforeMortgageVisible &&
          this.application.Fee.IsValuationCompletedBeforeCode !== ReferenceDataOptionLists.AnswerTypeNo
        ));
  }

  public onIsValuationCompletedBeforeCodeChange(value: string): void {
    this.application.Fee.IsValuationCompletedBeforeCode = value;
    if (value !== ReferenceDataOptionLists.AnswerTypeNo) {
      this.isValuationReportTypeCodeVisible = false;
      this.application.Fee.ValuationReportTypeCode = undefined;
    } else {
      this.isValuationReportTypeCodeVisible = true;
    }
  }

  public onValuationReportTypeChange(): void {
    if (this.application.Fee.ValuationReportTypeCode === ReferenceDataOptionLists.ValuationReportTypeBuildingSurvey) {
      this.isBuildingSurveyNoteVisible = true;
    }

    this.updateValuationFee();
  }

  private updateValuationFee(): void {
    if (this.application.Fee) {
      this.application.Fee.setValuationFee();
    }
  }

  public isReportCompletedBeforeMortgage(): boolean {
    let isReportCompleted: boolean;
    if (this.application.Fee) {
      if (this.application.Fee.IsValuationCompletedBeforeCode === ReferenceDataOptionLists.AnswerTypeYes) {
        isReportCompleted = true;
      } else {
        this.application.Fee.ValuationReportPayerTypeCode = undefined;
      }
    }

    return isReportCompleted;
  }

  public isPayerTypeApplicant(): boolean {
    let isPayerApplicant: boolean;
    if (this.application.Fee) {
      if (
        this.application.Fee.ValuationReportPayerTypeCode === ReferenceDataOptionLists.ValuationReportPayerTypeApplicant
      ) {
        isPayerApplicant = true;
      } else {
        this.application.Fee.ValuationCompanyName = undefined;
        this.application.Fee.ValuationCompletedValue = undefined;
      }
    }

    return isPayerApplicant;
  }

  public isPayerTypeVendor(): boolean {
    let isPayerVendor: boolean;
    if (this.application.Fee) {
      if (
        this.application.Fee.ValuationReportPayerTypeCode === ReferenceDataOptionLists.ValuationReportPayerTypeVendor
      ) {
        isPayerVendor = true;
      } else {
        this.application.Fee.WhoCompletedSurvey = undefined;
      }
    }

    return isPayerVendor;
  }
}
